import identity from './identity';
import moment from 'moment-timezone';
import axios from 'axios';
import CoreApiClient from '../../core-api-client';
import config from '../../../config';
const locale = (window.navigator.languages && window.navigator.languages[0]) ||
               window.navigator.language ||
               window.navigator.userLanguage ||
               window.navigator.browserLanguage;

const _timezone = moment.tz.guess() || 'Asia/Tokyo';

// Instance of Axios.
const _http = axios.create({
  //baseURL: process.env.REACT_APP_CORE_API_ENDPOINT,
  baseURL: config.CORE_API_ENDPOINT,
});

const coreApi = new CoreApiClient({http:_http});

export default {
  // Access token of login user. (persist)
  identity,
  // User data of who login.
  me: null,
  // Selection (persist)
  selectedLocale: locale,
  selectedTimezone: _timezone,
  selectedAccount: null,
  selectedCampaign: null,
  changeSelectedAccountVersion: 0,
  changeSelectedCampaignVersion: 0,
  changeSelectedTermVersion: 0,
  selectedTerm: {
    beginTimestamp: moment().subtract(30, 'days').startOf('days').format('x'),
    endTimestamp: moment().endOf('days').format('x'),
  },
  // Prevent manipulate user when this is true.
  isRequesting: false,
  requesting: 0,
  doesRequireReload: false,
  // Error message
  lastError: '',
  lastErrorDescription: '',
  // For /log/audienceLog page only.
  configOfAudienceLog: {
    pageSize: 100,
    sorted: [{id: 'visitedAt', desc: true}],
    columns: {},
  },
  // For /log/callLog page only.
  configOfCallLog: {
    pageSize: 100,
    sorted: [{id: 'visitedAt', desc: true}],
    columns: {},
  },
  // for /accounts page only.
  configOfAccounts: {
    pageSize: 100,
    sorted: [{id: 'createdAt', desc: true}],
    columns: {},
  },
  // for /campaigns page only.
  configOfCampaigns: {
    pageSize: 100,
    sorted: [{id: 'createdAt', desc: true}],
    columns: {},
  },
  configOfTrackingNumbers: {
    pageSize: 100,
    sorted: [{id: 'createdAt', desc: true}],
    columns: {},
  },
  // for /observers page only.
  configOfObservers: {
    pageSize: 100,
    sorted: [{id: 'priority', desc: true}],
    columns: {},
  },
  http: _http,
  coreApi,
  initializeDone: false,
  controlledHttpClient: null,
  schema: {},
  timeoutId: undefined,
};
